import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";

import { FlexRow } from "app/pages/website-analysis/website-content/leading-folders/components/Tab";

export const WebsiteName = styled.div`
    ${mixins.setFont({ $color: colorsPalettes.carbon[400], $size: 14 })};
    margin-right: 20px;
    margin-left: 7px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 14vw;
    @media (max-width: 1400px) {
        max-width: 9vw;
    }
`;

export const BannerContainer = styled.div`
    width: 100%;
    margin-bottom: 26px;
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
`;

export const StyledSWReactIcons = styled(SWReactIcons)`
    height: 56.9px;
    width: 56.9px;
`;

export const IconWrapper = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.midnight[50]};
    box-shadow: 0 2px 4px 0 rgba(${colorsPalettes.carbon[200]}, 0.2);
    position: relative;

    img {
        margin: 0;
    }
`;

export const VersusWrapper = styled.span`
    margin-right: 20px;
`;

export const SimilarSitesWrapper = styled(FlexRow)`
    width: 100%;
    margin-top: 7px;
`;
